export enum scheduleTypeValues {
  leave = 'leave',
  arrive = 'arrive',
}

export type ScheduleTypes = scheduleTypeValues.leave | scheduleTypeValues.arrive;
